import styled from 'styled-components'

interface Props {
  backgroundColor?: string
  color?: string
  isChild?: any
}

export const ContainerBox = styled.div`
  background: gray;
  height: 1px;
  width: 6%;
  ::before {
    background: blue;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: -22px;
    width: 1px;
  }
`

export const Flex = styled.div<Props>`
  align-items: center;
  display: flex;
  margin-top: ${props => (props.isChild ? '2%' : 0)};
`

export const ContainerFlex = styled.div<Props>`
  align-items: center;
  background-color: ${props => props.backgroundColor || 'white'};
  border-radius: 10px;
  border: 1px solid;
  color: ${props => props.color};
  cursor: pointer;
  display: flex;
  height: 44px;
  width: 35%;
  z-index: 3;

  p {
    font-family: 'Nunito Sans';
    font-weight: 600;
    margin-bottom: 0px;
    margin-left: 10px;
  }
`

export const WrapIcon = styled.div`
  margin-left: 10px;
  width: 18px;
`

export const Title = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
